/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationPaymentBillingTransactionsResponseData,
  GetOrganizationPaymentBillingTransactionsResponseDataFromJSON,
  GetOrganizationPaymentBillingTransactionsResponseDataFromJSONTyped,
  GetOrganizationPaymentBillingTransactionsResponseDataToJSON
} from './GetOrganizationPaymentBillingTransactionsResponseData'

/**
 *
 * @export
 * @interface GetOrganizationPaymentBillingTransactionsResponse
 */
export interface GetOrganizationPaymentBillingTransactionsResponse {
  /**
   *
   * @type {number}
   * @memberof GetOrganizationPaymentBillingTransactionsResponse
   */
  status: number
  /**
   *
   * @type {GetOrganizationPaymentBillingTransactionsResponseData}
   * @memberof GetOrganizationPaymentBillingTransactionsResponse
   */
  data: GetOrganizationPaymentBillingTransactionsResponseData
}

export function GetOrganizationPaymentBillingTransactionsResponseFromJSON(
  json: any
): GetOrganizationPaymentBillingTransactionsResponse {
  return GetOrganizationPaymentBillingTransactionsResponseFromJSONTyped(json, false)
}

export function GetOrganizationPaymentBillingTransactionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationPaymentBillingTransactionsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: GetOrganizationPaymentBillingTransactionsResponseDataFromJSON(json['data'])
  }
}

export function GetOrganizationPaymentBillingTransactionsResponseToJSON(
  value?: GetOrganizationPaymentBillingTransactionsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationPaymentBillingTransactionsResponseDataToJSON(value.data)
  }
}
